import { createClient } from '@supabase/supabase-js';

const supabaseUrl=String(import.meta.env.VITE_SUPABASE_URL||'').trim();
const supabasePublishableKey=String(
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  ||import.meta.env.VITE_SUPABASE_ANON_KEY
  ||'',
).trim();
const DEFAULT_AUTH_CONFIRMATION_URL='https://theturbocrown.com/auth/confirmed/';
const configuredAuthConfirmationUrl=String(
  import.meta.env.VITE_SUPABASE_AUTH_REDIRECT_URL||DEFAULT_AUTH_CONFIRMATION_URL,
).trim();

let client=null;

export function isSupabaseConfigured(){
  return Boolean(supabaseUrl&&supabasePublishableKey);
}

export function getSupabaseConfiguration(){
  return {
    configured:isSupabaseConfigured(),
    url:supabaseUrl,
  };
}

export function getSupabaseAuthRedirectUrl(){
  try{
    const url=new URL(configuredAuthConfirmationUrl);
    return ['http:','https:'].includes(url.protocol)?url.href:DEFAULT_AUTH_CONFIRMATION_URL;
  }catch{
    return DEFAULT_AUTH_CONFIRMATION_URL;
  }
}

export function getSupabaseClient(){
  if(!isSupabaseConfigured())return null;
  if(!client){
    client=createClient(supabaseUrl,supabasePublishableKey,{
      auth:{
        persistSession:true,
        autoRefreshToken:true,
        detectSessionInUrl:true,
        storageKey:'carscape-supabase-auth-v1',
      },
    });
  }
  return client;
}
